
import { useState, useEffect } from 'react';
import { supabase } from "@/integrations/supabase/client";

export const useLocalFavoritesData = (favorites: number[]) => {
  const [favoriteVacations, setFavoriteVacations] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchFavoriteVacations = async (favoriteIds: number[]) => {
    console.log('fetchFavoriteVacations called with:', favoriteIds);
    if (favoriteIds.length === 0) {
      setFavoriteVacations([]);
      return;
    }

    setLoading(true);
    try {
      console.log('Fetching vacations for IDs:', favoriteIds);
      const { data, error } = await supabase
        .from('TUI')
        .select('*')
        .in('product ID', favoriteIds);

      if (error) throw error;
      console.log('Fetched favorite vacations:', data);
      setFavoriteVacations(data || []);
    } catch (error) {
      console.error('Error fetching favorite vacations:', error);
      setFavoriteVacations([]);
    } finally {
      setLoading(false);
    }
  };

  // Initial fetch
  useEffect(() => {
    console.log('Initial fetch useEffect triggered with favorites:', favorites);
    fetchFavoriteVacations(favorites);
  }, [favorites]);

  // Listen for favorites changes from other components
  useEffect(() => {
    const handleFavoritesChanged = (event: CustomEvent) => {
      console.log('Favorites changed event received:', event.detail);
      fetchFavoriteVacations(event.detail);
    };

    window.addEventListener('favoritesChanged', handleFavoritesChanged as EventListener);
    return () => {
      window.removeEventListener('favoritesChanged', handleFavoritesChanged as EventListener);
    };
  }, []);

  return { favoriteVacations, loading };
};
